/* eslint-disable @typescript-eslint/naming-convention */
import Category from 'features/pricing/components/category';
import type { ReactElement } from 'react';
import React from 'react';
import type { Service, ServiceCategory } from 'types/services';
import { validateString } from 'utils/validate-string';

import styles from './price-list.module.scss';

interface Props {
  readonly category: ServiceCategory;
  readonly level: number;
}

const listClass = validateString(styles.list);

const ONE = 1;

function mapServiceToElement(service: Service): ReactElement {
  return (
    <li key={service._key ?? service.label}>
      <span>{service.label}</span>
      <span>${service.price}+</span>
    </li>
  );
}

export default function PriceList({
  category,
  level,
}: Readonly<Props>): ReactElement {
  const { services } = category;

  return (
    <ul className={listClass}>
      {services.map(service => {
        if (service._type === 'service') {
          return mapServiceToElement(service);
        }

        return (
          <Category
            category={service}
            key={service._key ?? service.categoryLabel}
            level={level + ONE}
          />
        );
      })}
    </ul>
  );
}
